import { createApiClient } from "@uavity-core/api-client";

export const api = createApiClient(
  import.meta.env.VITE_API_URL_V1 || "http://localhost:8080/api/v1",
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("auth_token");
      window.location.href = "/";
    }
    return Promise.reject(error);
  },
);
